import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const BuildingIcon = ({ className }: IProps) => {
  const iconClassName = classNames('building-icon', className);

  return (
    <svg className={iconClassName} width='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.5834 7.49317L9.17004 6.4912L9.58012 5.42712L12.6875 6.71726V12.8355H11.5834V7.49317Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.08333 9.47921C3.84171 9.47921 3.64583 9.67509 3.64583 9.91671L3.64583 12.8334H1.3125L1.3125 1.16671C1.3125 1.0315 1.37503 0.903874 1.48188 0.821005C1.58873 0.738134 1.72789 0.709329 1.85886 0.742974L9.77083 2.77552L9.77083 12.8334L7.4375 12.8334V9.91671C7.4375 9.67509 7.24162 9.47921 7 9.47921H4.08333ZM6.5625 12.8334H4.52083V10.3542H6.5625V12.8334ZM7 5.68755L4.08333 5.68755V4.81255H7V5.68755ZM7 8.02088H4.08333L4.08333 7.14588L7 7.14588V8.02088Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.583374 12.1042L13.4167 12.1042V13.2709L0.583374 13.2709L0.583374 12.1042Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default BuildingIcon;
